// Stat-card preferences (localStorage, settings-level). Mirrors Android:
//   * Four swappable slots, each pinned to one of the 8 TaskListStatType keys.
//     Defaults match Android's TaskListScreenState: Total / Actions / Billing /
//     Spent. A type can sit in only one slot at a time.
//   * A display mode controlling the whole row's visibility.
import { STAT_TYPES } from "./taskListStats";

const SLOTS_KEY = "stat_card_slots";
const DISPLAY_MODE_KEY = "stat_cards_display_mode";

export const DEFAULT_SLOTS = [
  "TOTAL_TASKS",
  "TOTAL_ACTIONS",
  "BILLING",
  "SPENT_TIME",
];

const VALID_KEYS = new Set(STAT_TYPES.map((s) => s.key));

// Stat Cards Display Mode — same three options as Android's StatCardsDisplayMode.
export const STAT_DISPLAY_MODES = [
  { value: "SHOW_NON_EMPTY", label: "Show Non Empty" },
  { value: "ALWAYS_SHOW", label: "Always Show" },
  { value: "HIDE", label: "Hide" },
];
export const DEFAULT_DISPLAY_MODE = "SHOW_NON_EMPTY";

export function getStatSlots() {
  try {
    const parsed = JSON.parse(localStorage.getItem(SLOTS_KEY));
    if (
      Array.isArray(parsed) &&
      parsed.length === 4 &&
      parsed.every((k) => VALID_KEYS.has(k)) &&
      new Set(parsed).size === 4 // no duplicates
    ) {
      return parsed;
    }
  } catch {
    // fall through to default
  }
  return [...DEFAULT_SLOTS];
}

// Assign `key` to `slotIndex`. If that type already sits in another slot, the
// two swap so the four slots always hold four distinct types (Android prevents
// picking a used type; swapping is the web-friendly equivalent).
export function setStatSlot(slotIndex, key) {
  if (!VALID_KEYS.has(key) || slotIndex < 0 || slotIndex > 3) {
    return getStatSlots();
  }
  const slots = getStatSlots();
  const existingIndex = slots.indexOf(key);
  if (existingIndex === slotIndex) return slots;
  if (existingIndex !== -1) {
    slots[existingIndex] = slots[slotIndex]; // swap the displaced type back
  }
  slots[slotIndex] = key;
  localStorage.setItem(SLOTS_KEY, JSON.stringify(slots));
  return slots;
}

export function getStatCardsDisplayMode() {
  const v = localStorage.getItem(DISPLAY_MODE_KEY);
  return STAT_DISPLAY_MODES.some((m) => m.value === v)
    ? v
    : DEFAULT_DISPLAY_MODE;
}

export function setStatCardsDisplayMode(mode) {
  if (STAT_DISPLAY_MODES.some((m) => m.value === mode)) {
    localStorage.setItem(DISPLAY_MODE_KEY, mode);
  }
}
